import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './store/auth.module'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  barColor: '',
  barImage: '',
  drawer: null,
  selectedModule: JSON.parse(sessionStorage.getItem('selectedModule')) || null,
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  SET_BAR_IMAGE (state, payload) {
    state.barImage = payload
  },
  SET_DRAWER (state, payload) {
    state.drawer = payload
  },
  setSelectedModule (state, moduleData) {
    state.selectedModule = moduleData
    sessionStorage.setItem('selectedModule', JSON.stringify(moduleData))
  },
  clearSelectedModule (state) {
    state.selectedModule = null
    sessionStorage.removeItem('selectedModule')
  },
}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    auth,
  },
  actions: {
  },
})